var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.00007L15 7.50007M10.8334 16.6667H17.5M4.16671 13.3334L3.33337 16.6667L6.66671 15.8334L16.3217 6.17841C16.6342 5.86586 16.8097 5.44201 16.8097 5.00007C16.8097 4.55813 16.6342 4.13429 16.3217 3.82174L16.1784 3.67841C15.8658 3.36596 15.442 3.19043 15 3.19043C14.5581 3.19043 14.1343 3.36596 13.8217 3.67841L4.16671 13.3334Z",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMenu);
export default __webpack_public_path__ + "static/media/editMenu.1a9d3cea5c0ef9d5f455e8cc8fb7a142.svg";
export { ForwardRef as ReactComponent };